import React from "react";

function FadeInSection(props) {
    const [isVisible, setVisible] = React.useState(false); // State to track visibility
    const domRef = React.useRef(null);

    React.useEffect(() => {
        const currentRef = domRef.current; // Store the ref value in a local variable

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setVisible(true); // Set to visible when in view
                    } else {
                        setVisible(false); // Optional: Reset when out of view
                    }
                });
            },
            { threshold: 0.1 } // Adjust the threshold if needed
        );

        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef); // Cleanup
            }
        };
    }, []);

    return (
        <div
            className={`fade-in-section ${isVisible ? "is-visible" : ""}`}
            ref={domRef}
        >
            {props.children}
        </div>
    );
}

export default FadeInSection;
